import {Stack, Typography} from '@mui/material';

type EmptyStateProps = {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
};

export const EmptyState = ({title, subtitle, icon}: EmptyStateProps) => (
  <Stack alignItems='center' justifyContent='center' direction='column' spacing={1}>
    {icon}
    <Typography variant='h5' color='primary' mt={0.5}>
      {title}
    </Typography>
    <Typography variant='h6'>{subtitle}</Typography>
  </Stack>
);
